import { render } from "./shade.vue?vue&type=template&id=22cf148e"
import script from "./shade.vue?vue&type=script&lang=js"
export * from "./shade.vue?vue&type=script&lang=js"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__